import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { PIKKO } from "../../lib/pikko";

const ease = [0.2, 0.8, 0.2, 1];

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-24 md:py-32 overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, var(--pikko-cream) 0%, var(--pikko-cream-deep) 100%)",
      }}
    >
      <div
        aria-hidden
        className="absolute inset-x-0 top-0 h-[1px]"
        style={{
          background:
            "linear-gradient(90deg, transparent, rgba(138,107,82,0.25), transparent)",
        }}
      />
      <div
        aria-hidden
        className="absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full opacity-30 blur-3xl"
        style={{
          background:
            "radial-gradient(circle, rgba(217,140,63,0.22), transparent 60%)",
        }}
      />

      <div className="relative max-w-5xl mx-auto px-5 sm:px-8 text-center">
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="eyebrow"
        >
          — Begin your journey with Pikko
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 22 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.95, ease }}
          className="mt-5 font-serif text-4xl sm:text-5xl lg:text-[68px] leading-[1.04] tracking-tight text-[var(--pikko-brown-ink)]"
        >
          Your pet deserves{" "}
          <span className="italic text-[var(--pikko-orange)]">
            professional
          </span>{" "}
          care.
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1, ease }}
          className="mt-7 max-w-2xl mx-auto text-[15px] leading-relaxed text-[var(--pikko-brown-deep)]/85"
        >
          Konsultasikan kebutuhan kesehatan dan perawatan hewan kesayangan Anda
          bersama tim Pikko Pet Care di Jatiasih Bekasi.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.2, ease }}
          className="mt-10 flex flex-wrap gap-4 justify-center"
        >
          <a
            href={PIKKO.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-book-btn"
            className="btn-primary"
          >
            <MessageCircle className="w-4 h-4" /> Book Appointment
          </a>
          <a
            href={PIKKO.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-contact-btn"
            className="btn-ghost"
          >
            <Phone className="w-4 h-4" /> Contact Us
          </a>
        </motion.div>
      </div>
    </section>
  );
}
